import React from "react";

function DevelopmentProjects({ projects, openModal }) {
  return projects.map((project) => (
    <figure
      key={project.title}
      className="project-tile"
      onClick={() => openModal(project)}
    >
      <img
        src={require(`../../assets/images/${project.project_image}`)}
        alt={project.title}
        className="blackandwhite"
      />
      <figcaption>
        <div>
          <h2>{project.title}</h2>
          <h3>MORE</h3>
        </div>
        <div>
          <p>{project.short_description}</p>
          <h4>INFO</h4>
        </div>
      </figcaption>
    </figure>
  ));
}

export default DevelopmentProjects;
